module.exports = __webpack_public_path__ + "static/img/img_card_kb.82a0a5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mall/img_card_kb.png
// module id = zeM3
// module chunks = 1